/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from './WithParamsAndNavigate';


class EConnection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            countdown: 5
        };
        this.tick = this.tick.bind(this);
        this.isConnectedCallback = props.isConnectedCallback;
        this.ref = props.params.ref ? atob(props.params.ref) : null;
    }


    componentDidMount() {
        if (!this.interval)
            this.interval = setInterval(this.tick, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    tick() {
        if (this.isConnectedCallback()) {
            if (this.ref)
                this.props.navigate(this.ref);
            else
                this.props.navigate('/');
        }
        var countdown = this.state.countdown;
        if (countdown <= 0)
            countdown = 6;
        this.setState({ countdown: countdown - 1 });
    }

    render() {
        return (<div className="container-fluid"><h1>Connection Error</h1><div className="alert alert-danger"><FontAwesomeIcon icon={fa.faExclamationTriangle} /> Could not connect to server. Will automatically retry to reconnect and restore session... ({this.state.countdown})</div></div>);
    }
}

export default withParamsAndNavigate(EConnection);